import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AccountInfo, CreateAccountParams, CreateAccountResult, UserDuplicateLookupParams } from '@se-po/shared-data-access-models'
import { BehaviorSubject } from 'rxjs'
import { UserServiceResources as us } from 'se-resource-types'

export class DocsAccountStore implements StoreService {
  public accountInfo = {} as AccountInfo
  public authSession = {} as us.AuthSession
  public accountValid = true
  public authSessionEmailAddress = 'test@example.test'
  public basePath = '/docs'
  public captchaResponse = ''
  public createdAccount = new BehaviorSubject<CreateAccountResult | null>({} as CreateAccountResult)
  public createAccountParams = {} as CreateAccountParams
  public createdAccountValid = true
  public dateOfBirth = ''
  public disableEmail = false
  public dupesChecked = false
  public dupes: any = {
    date_of_birth: '2020-02-02',
    first_name: 'XYZ',
    email: 'xyz@xxx.xxx',
    id: 1,
    last_name: 'XXX',
    phone: '555-555-5555',
    user_duplicate_lookup_results: [{
      confidence: 'low',
      created_at: '2020-02-02',
      found_user_last_login: '2020-02-02',
      found_user_obfuscated_email: 'xxx@***.xxx',
      found_user_uuid: '123-456-789',
      id: 1,
      status: 'dupe',
      updated_at: '2020-02-02',
      user_duplicate_lookup_id: 1,
    },{
      confidence: 'medium',
      found_user_last_login: null,
      found_user_obfuscated_email: 'xyz@***.xyz',
      found_user_uuid: '555-456-789',
      id: 1,
      status: 'dupe',
      updated_at: '2020-01-02',
      user_duplicate_lookup_id: 1,
    }]
  }
  public emailAddress = ''
  public invite = {} as us.Invitation
  public nextPath: string
  public userReturnTo = ''
  public userDuplicateLookupParams = {} as UserDuplicateLookupParams
  public patchAccountInfo(): void {
    // n00p
  }
  public patchChildInfo(): void {
    // n00p
  }
  public reset(): void {
    // noop
  }
}
